var _defs, _path, _path2, _path3, _path4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKenya(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 900,
    height: 600
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "kenya_svg__a",
    d: "M-1 55.426h2V-38c2-2 2-5 2-8 0-2 0-10-3-18.663C-3-56-3-48-3-46c0 3 0 6 2 8z",
    strokeMiterlimit: 10,
    transform: "rotate(30)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h900v600H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h900v180H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#b00",
    d: "M0 210h900v180H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#060",
    d: "M0 420h900v180H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.75 0 0 3.75 450 300)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kenya_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kenya_svg__a"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kenya_svg__a",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kenya_svg__b",
    transform: "scale(-1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-19 24c3 8 13 24 19 24s16-16 19-24v-48C16-32 6-48 0-48s-16 16-19 24z",
    fill: "#b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kenya_svg__c",
    d: "M19 24c3-8 5-16 5-24s-2-16-5-24c-3 8-5 16-5 24s2 16 5 24z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kenya_svg__c",
    transform: "scale(-1 1)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 4,
    ry: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "kenya_svg__d",
    d: "M1 5.85s4 8 4 21-4 21-4 21z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kenya_svg__d",
    transform: "scale(-1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kenya_svg__d",
    transform: "scale(-1 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kenya_svg__d",
    transform: "scale(1 -1)"
  })))));
}
export default __webpack_public_path__ + "assets/static/media/kenya.bd24673f.svg";
export { SvgKenya as ReactComponent };